import React from "react";

export default function AribaHeaderTable({response}) {
  const data = [
    { status: "Grand Total", RFI: response?.RFIEvents, RFP: response?.RFPEvents, AUCTION: response?.auctionEvents, highlight: true, bold: true },
    { status: "Pending Selection", RFI: response?.RFIPendingSelectionEvents, RFP: response?.RFPPendingSelectionEvents, AUCTION: response?.auctionPendingSelectionEvents, bold: true },
    { status: "Completed", RFI: response?.RFICompletedEvents, RFP: response?.RFPCompletedEvents, AUCTION: response?.auctionCompletedEvents, bold: true }
  ];

  return (
    <div className="ariba-table-container">
      <table className="ariba-custom-table">
        <thead>
          <tr style={{textAlign: 'left'}}>
            <th style={{background: 'white'}}></th>
            <th className="ariba-header-table" style={{background: 'white'}}>RFI</th>
            <th className="ariba-header-table" style={{background: 'white'}}>RFP</th>
            <th className="ariba-header-table" style={{background: 'white'}}>AUCTION</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, index) => (
            <tr 
              key={index}
              className={`${row.highlight ? "ariba-highlight-row" : ""}`}
              // style={row.status == "Pending Selection" ? {borderBottom: '2px solid #dce7f9'} : {}}
              style={{border: '2px solid #dce7f9'}}
            >
              <td className={row.bold ? "ariba-header-table-column1" : ""} style={{width: '8rem'}}>{row.status}</td>
              <td className="ariba-header-table-cell" style={{width: "6rem",fontWeight: row.status === "Grand Total" ? 700 : ""}}>{row.RFI}</td>
              <td className="ariba-header-table-cell" style={{width: '6rem',fontWeight: row.status === "Grand Total" ? 700 : ""}}>{row.RFP}</td>
              <td className="ariba-header-table-cell" style={{width: '6rem',fontWeight: row.status === "Grand Total" ? 700 : ""}}>{row.AUCTION}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
